import { LogLevel } from './log-level.enum';

/**
 * Delegate function definition for indicating wether an incoming log entry should be picked up.
 */
export type LogFilter = (logSource: string, message: string, payload: any, level: LogLevel) => boolean;
